/*
 * @Author: huangzq
 * @Date: 2020-04-10 22:07:02
 * @Last Modified by: zhouwei
 * @Last Modified time: 2020-04-14 19:35:31
 * @Desc: 部门/成员选择器-新版
*/
<template>
  <div class="dept-member-select">
    <template v-if="!useSelect">
      <dept-member
        ref="deptMember"
        :use-select="false"
        :width="width"
        :show="show"
        :can-select-company="canSelectCompany"
        :can-select-dept="canSelectDept"
        :init-dept-list="comInitDeptList"
        :init-member-list="comInitMemberList"
        :init-all-dept="initDeptList"
        :init-all-member="initMemberList"
        :is-single="isSingle"
        @cancel="cancelSelect"
        @confirm="confirmSelect"
      />
    </template>
    <template v-else>
      <mk-select
        ref="select"
        v-model="memberNameList"
        :use-select="true"
        :init-all-dept="initDeptList"
        :init-all-member="initMemberList"
        :width="width"
        multiple
        clearable
        collapse-tags
        :placeholder="placeholder"
        popper-class="depart-member-mulitiple-select"
        :disabled="disabled"
        @clear="clear"
        @visible-change="visibleChange"
      >
        <mk-option
          label
          value
          disabled
        >
          <dept-member
            ref="deptMember"
            :width="width"
            :show="show"
            :can-select-company="canSelectCompany"
            :can-select-dept="canSelectDept"
            :init-dept-list="comInitDeptList"
            :init-member-list="comInitMemberList"
            :init-all-dept="initDeptList"
            :init-all-member="initMemberList"
            :is-single="isSingle"
            @cancel="cancelSelect"
            @confirm="confirmSelect"
          />
        </mk-option>
      </mk-select>
    </template>
  </div>
</template>
<script>
import deptMember from './components/dept-member'
export default {
  name: 'DeptMemberSelect',
  components: {
    deptMember
  },
  model: {
    prop: 'data',
    event: 'change'
  },
  props: {
    canSelectCompany: {
      // 公司是否可选
      type: Boolean,
      default: false
    },
    // 当下选择部门/成员数据
    data: {
      type: Object,
      default () {
        return {
          dept: [],
          member: []
        }
      }
    },
    // 是否使用select下拉框
    useSelect: {
      type: Boolean,
      default: true
    },
    // 部门是否可选（当isSingle为true时，部门必不可选）
    canSelectDept: {
      type: Boolean,
      default: true
    },
    // 是否为单选
    isSingle: {
      type: Boolean,
      default: false
    },
    // 未选择时默认文案
    placeholder: {
      type: String,
      default: '请选择'
    },
    // 宽度
    width: {
      type: [String, Number],
      default: 420
    },
    // 获取部门接口api配置
    deptApi: {
      type: Object,
      default () {
        return {
          name: ACCOUNTAPIS.OrganisationApi.v1OrganisationFindDepListGet,
          params: {}
        }
      }
    },
    // 获取成员接口api配置
    memberApi: {
      type: Object,
      default () {
        return {
          name: ACCOUNTAPIS.OrganisationApi.v1OrganisationAllGet,
          params: {}
        }
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      show: false,
      // 初始部门信息
      initDeptList: [],
      // 初始成员信息
      initMemberList: [],
      memberNameList: [] // 成员名字数组
    }
  },
  computed: {
    comInitDeptList () {
      return this.data.dept
    },
    comInitMemberList () {
      let arr = []
      if (this.data.member instanceof Array) {
        this.data.member.forEach(item => {
          arr.push({
            userId: item.id,
            ...item
          })
        })
      }
      return arr
    }
  },
  watch: {
    data: {
      handler: function (val) {
        this.getMemberNameList()
      },
      deep: true,
      immediate: true
    }
  },
  created () {
    this.getDeptList()
    this.handlePropsData()
    this.getMemberNameList()
  },
  methods: {
    clear (e) {
      this.$emit('change', {
        dept: [],
        member: []
      })
      this.$emit('change-ids', {
        deptId: [],
        memberId: []
      })
      this.$emit('change-data', {
        departmentIds: [],
        userIds: [],
        all: true
      })
    },
    async getDeptList () {
      this.show = false

      // 获取部门信息
      const res = await this.deptApi.name(this.deptApi.params)
      if (res.success) {
        this.initDeptList = res.data
        this.getMembList()
      }
    },
    async getMembList () {
      // 获取成员列表
      const res = await this.memberApi.name(this.memberApi.params)
      if (res.success) {
        this.initMemberList = res.data
        this.show = true
      }
    },

    getMemberNameList () {
      let arr = this.data.dept.concat(this.data.member)
      let memberNameList = []
      arr.forEach(item => {
        memberNameList.push(item.name)
      })
      this.memberNameList = memberNameList
    },
    handlePropsData () {
      this.data.member.forEach(item => {
        item.userId = item.id
      })
    },
    confirmSelect (data) {
      if (this.useSelect) {
        this.$refs.select.$children[0].blur()
      }
      // 处理select选中结果
      let memberNameList = []
      let arr = data.dept.concat(data.member)
      arr.forEach(item => {
        memberNameList.push(item.name)
      })
      this.memberNameList = memberNameList
      // v-model绑定值
      this.$emit('change', {
        dept: data.dept,
        member: data.member
      })

      // 新增change-ids事件，只返回处理了的id数组
      this.$emit('change-ids', {
        deptId: data.dept.map(item => item.id),
        memberId: data.member.map(item => item.id)
      })
      // 此逻辑同后端
      // departmentIds: 部门id列表, userIds: 成员id列表, all: 是否查询公司信息
      if (data.dept.length === 0 && data.member.length === 0) {
        this.$emit('change-data', {
          departmentIds: [],
          userIds: [],
          all: true
        })
      } else if (data.dept.length === 1 && data.dept[0].id === 'NA') {
        this.$emit('change-data', {
          departmentIds: [],
          userIds: [],
          all: true
        })
      } else {
        this.$emit('change-data', {
          departmentIds: data.dept.map(item => item.id),
          userIds: data.member.map(item => item.id),
          all: false
        })
      }
    },
    cancelSelect () {
      if (this.useSelect) {
        this.$refs.select.$children[0].blur()
      } else {
        this.$refs.deptMember.updateData()
        this.$emit('on-cancel')
      }
    },
    visibleChange (state) {
      this.$emit('optionVisibleChange', state)
      this.$refs.deptMember.updateData(state)
    }
  }
}
</script>
<style lang="scss">
.depart-member-mulitiple-select {
  height: 386px;

  /deep/ .el-scrollbar {
    width: calc(100% + 2px);
    height: 386px;
  }

  /deep/ .el-select-dropdown__list {
    padding: 0;
  }

  /deep/ .el-select-dropdown__wrap {
    height: 405px;
    max-height: inherit !important;
  }

  /deep/ .el-select-dropdown__item {
    padding: 0;
    height: 386px;
    max-height: inherit;
  }
}
</style>
<style lang="scss" scoped>
.dept-member-select {
  /deep/ .el-tag__close {
    display: none !important;
  }
}
</style>
